export default __webpack_public_path__ + "static/media/seal1.12781caf.jpeg";